<template>
  <div class="activity202203">
    <AppHeader/>
    <div class="act-threeMonth">
		<div class="top-banner">
      <img src="../../assets/images/activity/activity202203/banner.png"/>
    </div>
		<div class="info-content">
			<div class="gift-box">
				<div class="ctn-box">
					<div class="title-box"><span><em class="dot-box"></em>迎春专业版增值礼包<em class="dot-box r"></em></span></div>
					<div class="clearfix gift-ctn">
						<div class="left-box">
							<div class="tle-box">《大智慧专业版》电脑版</div>
							<div class="tle-tip">迎春专业版礼包内容：大智慧专业版电脑端一年，大智慧移动指标双突战法一年及神奇D信号一年，不可叠加。</div>
							<div class="tle-sm">大智慧移动端指标</div>
							<ul class="clearfix li-list block">
								<li class="li-item">双突战法</li>
								<li class="li-item">神奇D信号</li>
							</ul>

							<div class="clearfix price-box">
								<span class="price-num">1998元/年</span>
								<span class="fr buy-btn" @click="goUrl(3042)">立即购买</span>
							</div>
							<div class="pr-tip">注意事项：本礼包产品中的移动指标将单独计算使用期限，已经购买过移动双突战法及神奇D信号的客户，不可与本礼包中包含的双突战法及神奇D信号叠加使用。</div>
						</div>
						<div class="right-box"></div>
					</div>
				</div>
			</div>
			<div class="gift-box bggray">
				<div class="ctn-box">
					<div class="title-box"><span><em class="dot-box"></em>专业组合包<em class="dot-box r"></em></span></div>
					<div class="clearfix gift-ctn">
						<div class="left-box">
							<div class="tle-box">《大智慧专业版》电脑版</div>
							<div class="tle-tip">专业版组合包内容：大智慧专业版电脑端一年，大智慧移动指标8个一年（神奇D信号、双突战法、异动查、云梯通道、黄金通道、追击反转、九转交易、题材王，不可叠加）</div>
							<div class="tle-sm">移动8个指标</div>
							<ul class="clearfix li-list">
								<li class="li-item">神奇D信号</li>
								<li class="li-item">黄金通道</li>
								<li class="li-item">九转交易</li>
								<li class="li-item">异动查</li>
								<li class="li-item">双突战法</li>
								<li class="li-item">追击反转</li>
								<li class="li-item">云梯通道</li>
								<li class="li-item">题材王</li>
							</ul>
							<div class="clearfix price-box">
								<span class="price-num">5280元/年</span>
								<em class="fr buy-btn" @click="goUrl(3046)">立即购买</em>
							</div>
							<div class="pr-tip">注意事项：本礼包产品中的移动指标将单独计算使用期限，已经购买过移动相关（神奇D信号、双突战法、异动查、云梯通道、黄金通道、追击反转、九转交易、题材王）的客户，不可与本礼包中包含的移动8个相关指标叠加使用。</div>
						</div>
						<div class="right-box"></div>
					</div>
				</div>
			</div>
			<div class="panel1-box">
				<div class="ctn-box">
					<div class="title-box"><span><em class="dot-box"></em>策略智慧礼包<em class="dot-box r"></em></span></div>
					<div class="clearfix p-ctn">
						<div class="left-box">
							<ul class="t-list">
								<li class="t-item">《大智慧策略投资终端》电脑版</li>
								<li class="t-item">优选大师财富版大智慧移动端</li>
								<li class="t-item">大智慧APP指标（18个）</li>
							</ul>
						</div>
						<div class="right-box">
							<div class="tle-box sm">策略智慧礼包内容：策略投资终端一年+优选大师财富版一年+移动18指标一年</div>
							<div class="tle-tip">18个移动指标包含：云梯通道、双突战法、神奇D信号、九转交易、主力筹码追踪、黄金通道、波段王、白马智投、蓄势待发、追击反转、尾盘动能、资金搏击、题材王、异动查、情绪转点、机构热股、抢筹先锋、分时顶底，不可叠加</div>
							<div class="clearfix price-box">
								<span class="price-num">56000元/年</span>
								<span class="fr buy-btn" @click="goUrl(3041)">立即购买</span>
							</div>
						</div>
					</div>
					<div class="btm-tip">注意事项：本礼包产品中的移动指标将单独计算使用期限，已经购买过移动18个相关同类型指标的客户,不可与本礼包中包含的18个移动指标叠加使用。</div>
				</div>
			</div>

			<div class="panel2-box bggray">
				<div class="ctn-box">
					<div class="top-tle">特色指标案例：AI活跃度及波段之星（仅限策略投资终端）<a href="http://ke.dzh.com.cn/search?q=AI活跃度" target="_blank" class="tle-alink">AI活跃度视频讲解</a><a href="http://ke.dzh.com.cn/search?q=波段之星" target="_blank" class="tle-alink">波段之星视频讲解</a></div>
					<div class="img-box">
						<img src="../../assets/images/activity/activity202203/img1.png"/>
					</div>
				</div>
			</div>
			<div class="footer-box">
				<div class="ctn-box">
					<span class="c-f">活动须知：《大智慧专业版》、《大智慧策略投资终端》、《优选大师财富版》的双年卡，季卡，月卡均不参与活动。</span>
					<span class="r-f">入市有风险，投资需谨慎！</span>
				</div>
			</div>

		</div>

	</div>

  </div>
</template>


<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
	name: 'activity202203',
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',

    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {


  },
  methods: {
    goUrl (key, month=12) {
      let routerDate;
      // if (this.token && key !== 4024) {
      //   routerDate = this.$router.resolve({name: 'ClientProduct', query: {token: this.token, pid: key, month: month}})
      // } else {
      //   routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      // }
      routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: key,month: month}})
      let {href} = routerDate
      window.open(href, "_blank")
    },
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
* {
    margin: 0;
    padding: 0;
}
a{
	text-decoration: none;
}
ul,li{
	list-style: none;
}
$color:#FF6464;
$url:'../../assets/images/activity/activity202203/';
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.act-threeMonth{
	width: 100%;
	.top-banner{
		width: 100%;
		img{
      display: block;
      max-width: 100%;
    }
	}
	.info-content{
		margin-top: 40px;
		.bggray{
			background-color: #F9F9F9;
		}
		.ctn-box{
			width: 1200px;
			margin: 0 auto;
			.price-box{
				.price-num{
					font-size: 42px;
					color: $color;
					line-height: 50px;
					font-weight: bold;
				}
				.buy-btn{
          cursor: pointer;
					float: right;
					width: 160px;
					height: 50px;
					background: $color;
					box-shadow: 0px 2px 4px 0px rgba(241,73,87,0.5);
					border-radius: 35px;
					font-size: 24px;
					line-height: 50px;
					color: #FFFFFF;
					text-align: center;
					font-weight: bold;
					display: inline-block;
				}
			}
		}
		.title-box{
			font-size: 36px;
			color: #333333;
			font-weight: 500;
			display: block;
			width: 100%;
			text-align: center;
			padding: 50px 0;
			span{
				display: inline-block;
				position: relative;
        .dot-box{
          width: 6px;
          height: 6px;
          border-radius: 6px;
          background-color: $color;
          position: absolute;
          left: -58px;
          top: 10px;
          &:before,&:after{
            content: '';
            position: absolute;
            background-color: $color;
            border-radius: 10px;
          }
          &:before{
            width: 8px;
            height: 8px;
            left: -18px;
            top: 16px;
          }
          &:after{
            width: 12px;
            height: 12px;
            left: 16px;
            top: 14px;
          }
          &.r{
            left: auto;
            right: -58px;
            transform: rotateY(180deg);
          }
        }
			}
		}
		.gift-box{
			padding-bottom: 50px;
			.gift-ctn{
        background: url($url+'illus1.png')no-repeat 725px bottom/421px;
				.left-box{
					max-width: 570px;
					.tle-box{
						font-size: 28px;
						color: #333333;
						font-weight: 500;
						margin-bottom: 20px;
					}
					.tle-tip{
						font-size: 16px;
						color: #444444;
						line-height: 24px;
						font-weight: 500;
					}
					.tle-sm{
						font-size: 24px;
						color: #333333;
						font-weight: bold;
						margin: 30px 0 20px;
					}
					.li-list{
						.li-item{
							margin-bottom: 20px;
							font-size: 18px;
							color: #666666;
							font-weight: 500;
							position: relative;
							padding-left: 18px;
							line-height: 25px;
							display: inline-block;
							width: 123px;
							float: left;
							position: relative;
							&:before{
								content: '';
								width: 8px;
								height: 8px;
								border-radius: 10px;
								position: absolute;
								left: 0px;
								top: 8.5px;
								background-color: $color;
							}
						}
						&.block{
							.li-item{
								display: block;
								float: none;
							}
						}
					}
					.price-box{
						padding-top: 18px;
					}
					.pr-tip{
						font-size: 14px;
						color: #444444;
						line-height: 24px;
						font-weight: 500;
						margin-top: 20px;
					}
				}
			}
      &.bggray{
        .gift-ctn{
          background: url($url+'illus2.png')no-repeat 725px bottom/421px;
        }
      }
		}
		.panel1-box{
			.p-ctn{
				.left-box{
					padding-right: 50px;
					float: left;
					.t-list{
						.t-item{
							width: 376px;
							height: 73px;
							background: $color;
							border: 2px solid $color;
							border-radius: 6px;
							font-size: 24px;
							color: #FFFFFF;
							text-align: center;
							font-weight: 500;
							line-height: 73px;
							margin-bottom: 50px;
							box-sizing: border-box;
						}
					}
				}
				.right-box{
					float: left;
					width: 774px;
					.tle-box.sm{
						font-size: 24px;
						color: #333333;
						text-align: justify;
						font-weight: bold;
						margin-bottom: 30px;
					}
					.tle-tip{
						font-size: 18px;
						color: #444444;
						text-align: justify;
						font-weight: 500;
						margin-bottom: 98px;
					}
					.price-box{
						.price-num{

						}
						.buy-btn{

            }
					}
				}
			}
			.btm-tip{
				font-size: 18px;
				color: #444444;
				letter-spacing: 0;
				font-weight: 500;
				margin-bottom: 50px;
			}
		}
		.panel2-box{
			padding-top: 50px;
      padding-bottom: 20px;
			&:last-child{
				margin-bottom: 50px;
			}
			.top-tle{
				font-size: 28px;
				color: #222222;
				font-weight: 500;
				padding-bottom: 30px;
        .tle-alink{
          font-size: 16px;
          color: #2980B9;
          text-decoration: underline;
          margin-right:10px;
          display: inline-block;
        }
			}
			.img-box{
				width: 1200px;
				display: block;
				margin-bottom: 30px;
				background-color: #ddd;
				img{display: block;width: 100%;}
			}
			.text-list{
				display: flex;

				.l-item{
					flex: 1;
					width: 380px;
					height: 248px;
					background: #FF6464;
					box-shadow: 0px 1px 6px 0px rgba(255,100,100,0.5);
					border-radius: 10px;
					display: inline-block;
					float: left;
					padding: 16px 12px;
					box-sizing: border-box;
					margin-right: 30px;
					&:last-child{
						margin-right: 0;
					}
					.item-tle{
						font-size: 24px;
						color: #FFFFFF;
						font-weight: 500;
						padding-bottom: 20px;
					}
					.p-boxs{
						p{
							font-size: 18px;
							line-height: 28px;
							color: #FFFFFF;
							font-weight: 500;
							margin-bottom: 20px;
							&:last-child{
								margin-bottom: 0;
							}
						}
					}
				}
				&.l28{
					.l-item{
						.p-boxs{
							p{
								line-height: 28px;
							}
						}
						&:nth-child(2){
							flex: 1.438;
						}
					}
				}
			}
		}
		.footer-box{
			padding: 19px 0;
			box-sizing: border-box;
			text-align: center;
			border-top: 1px solid  #E5E5E5;
			.c-f{
				font-size: 16px;
				color: #666666;
				line-height: 22px;
				font-weight: 500;
			}
			.r-f{
				font-size: 16px;
				color: #F14957;
				line-height: 22px;
				font-weight: 500;
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/activity/activity202203.vue